<template>
  <div class="article">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <div class="c-title-wrap">
        <p class="c-title">基本内容</p>
      </div>
      <!-- 疫苗名称-->
      <disease-name :contentName.sync="form.contentName" actionType="16" />
      <!-- 别名 -->
      <contentAlias-Names :aliasName.sync="form.contentAliasNames" />
      <!-- 疫苗分类-->
      <check-box-class
        ref="vaccineLabelref"
        :functionIds="{
          queryVaccineCategories: 'health_cmp_biz_queryVaccineCategories',
        }"
        @checkoutVaccineLabel="checkoutVaccineLabel"
      />
      <!-- 付费情况 -->
      <payment :value.sync="form.contentVaccine.payType" />
      <!-- 接种几针 -->
      <inoculationNum :value.sync="form.contentVaccine.vaccinationCount" />
      <!-- 关联疾病 -->
      <contentLabel-cp
        :data="form.contentRelations"
        @changeDiseaseLabels="changeDiseaseLabels"
        :is-show-disease="isShowDisease"
        :functionIds="{ queryContents: 'health_cmp_queryContents' }"
      />
      <!-- 百科段落 -->
      <div
        class="content-item flex textArea-flex"
        style="position: relative"
        v-for="(item, index) in paragraphList"
        :key="index"
      >
        <div class="content-item-label">
          <span class="red">*</span>{{ item.desc }}
        </div>
        <c-editor
          v-if="item.style === 1"
          :content="item.content || ''"
          :index="index"
          @editorReady="editorReady"
          :ref="'editor' + index"
          @blurEditorEvent="blurEditorEvent"
        >
        </c-editor>
        <el-input
          v-if="item.style === 2"
          :key="index"
          show-word-limit
          type="textarea"
          maxlength="100"
          v-model="item.content"
          :placeholder="`请输入${item.desc}`"
          @input="editorChange(item.content, index)"
        ></el-input>
      </div>
      <!-- 关键词 -->
      <keywords ref="keywordsref" />
      <div class="finish-buttons">
        <el-button @click="saveOrUpdateDiseaseInfo(0, 'preview')"
          ><span>预览</span>
        </el-button>
        <el-button
          @click="saveOrUpdateDiseaseInfo(1, 'draft')"
          v-if="auditInfoShow !== 3"
          ><span>保存</span>
        </el-button>
        <el-button type="primary" @click="saveOrUpdateDiseaseInfo(2, 'submit')"
          ><span>提交</span>
        </el-button>
      </div>
    </div>
    <!-- ===================== 预览弹窗 ====================== -->
    <preview-modal
      :mUrl.sync="mUrl"
      :dialogPreVisible.sync="dialogPreVisible"
      :qrCode="qrCode"
    />
    <modal
      :isShow.sync="deleteForm.deleteDialog"
      title="删除"
      :isShowBtn="deleteForm.isShowBtn"
      :btnText="deleteForm.btnText"
      @clickHandler="deleteClickHandler"
    >
      <div class="dialogVal">需要删除所有疾病百科信息吗？</div>
    </modal>

    <modal
      :isShow.sync="reset_Diseases"
      title="更换疾病名称"
      :btnText="[]"
      :isShowBtn="[]"
      :width="'400px'"
      @clickHandler="repealclickHandler"
    >
      <div class="dialogVal">更改疾病将清空已填疾病的所有内容，是否继续?</div>
    </modal>
  </div>
</template>
<script>
import breadCrumb from "@/components/breadCrumb";
import modal from "@/components/modal";
import CheckBoxClass from "../../../../components/radio/CheckBoxClass.vue";
import payment from "@/components/radio/payment.vue";
import inoculationNum from "@/components/radio/inoculationNum.vue";
import CEditor from "@/components/editor/CEditor";
import contentLabelCp from "@/components/tag/contentLabelCp";
import PreviewModal from "@/components/pop/PreviewModal";
import contentAliasNames from "@/components/input/contentAliasNames";
import Keywords from "@/components/input/Keywords";
import WriteDoctor from "@/components/select/WriteDoctor";
import DiseaseName from "@/components/input/DiseaseName";
import { getQRCode } from "@/utils/tools";
import { request } from "@/utils/axios";

export default {
  data() {
    return {
      // 失去焦点编辑器保存提示成功时间，定时清除提示
      tipTimeout: null,
      //疾病搜索
      loading: false,
      //结束疾病搜索
      reset_Diseases: false, // 修改关联疾病名称
      //科室
      departmentList: [],
      selectedDeparttId: [],
      //结束科室
      paragraphList: [], // 段落
      paragraphListCategory: [],
      editorList: {},
      //结束编辑器相关
      //结束关键词
      originalTips: false,
      actionType: "",
      user_identity: 0, // 身份信息
      // 疾病百科信息集合
      checkoutList: [],
      form: {
        contentAliasNames: [],
        contentId: undefined, // 内容基本信息id
        tenantId: Number(this.$commonJs.getTenantId()), // 租户id
        contentName: "", // 内容名称
        aliasName: [], // 别名
        contentType: undefined, // 疾病类型 默认8疾病百科 9疾病百科
        contentRelations: [], // 关联的其他内容 仅需要id和type
        contentParagraphs: [], // 段落信息
        keywordInfos: [], // 内容关键词
        contentVaccine: {
          vaccineCategories: [],
          vaccinationCount: "",
          payType: 1,
        },
      },
      vaccineCategories: [],
      dialogPreVisible: false,
      // 删除弹框
      deleteForm: {
        deleteDialog: false,
        btnText: ["不删除", "删除"],
        isShowBtn: [true, true, false],
      },
      isShowDisease: false,
      inputVisible: false,
      inputValue: "",
      symptomsPartsValue: [], // 部位值
      auditInfoShow: "",
      contentStatus: "",
      arrPartsList: [],
    };
  },
  components: {
    modal,
    breadCrumb,
    contentLabelCp,
    CEditor,
    PreviewModal,
    contentAliasNames,
    inoculationNum,
    Keywords,
    WriteDoctor,
    DiseaseName,
    payment,
    CheckBoxClass,
  },
  created() {
    if (this.$route.query.id) {
      this.form.contentId = this.$route.query.id;
    }
    if (this.$route.query.articleType) {
      this.actionType = this.$route.query.articleType;
    }
  },
  async mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.cancel, false);
    }
    this.init();
    //获取段落
    await this.getContentParagraphDictionary();
    // 如果是编辑文章
    if (this.$route.query.id) {
      this.getDiseaseInfoDraftDetail();
    }
    // 点击空白地方，文章内容存到缓存里面，当刷新页面的时候能够回显
    var _this = this;
    var flag = true;
    var isjqTri = false;
    var selectRoleSetTimeout;
    $("#selectRole")
      .on("compositionstart", function () {
        flag = false;
      })
      .on("compositionend", function () {
        flag = true;
      })
      .on("input", function (e) {
        clearTimeout(selectRoleSetTimeout);
        if (!this.loading)
          selectRoleSetTimeout = setTimeout(function () {
            if (flag && !isjqTri) {
              isjqTri = true;
            } else {
              isjqTri = false;
            }
          }, 100);
      });
  },
  destroyed() {
    window.removeEventListener("popstate", this.cancel, false);
    // 移除段落缓存
    sessionStorage.removeItem("cache_articles");
  },
  methods: {
    cancel: function () {
      if (this.$route.query.id) {
        this.$router.push(`/manageBK`);
      }
    },
    blurEditorEvent(editor, index) {
      // 编辑文章不做临时保存操作
      /*if(this.form.contentId){
          return;
        }*/
      this.paragraphList[index].content = editor.getContent() || "";
      // var tipDom = $(
      //   '<div class="successfully" style="position: absolute; top: 0; right: 15px;color: green;">保存成功</div>'
      // );
      // let ParentElement = $(editor.editorContainer).find(".tox-toolbar__group").eq(0)
      // let subelement = ParentElement.find(".successfully")
      // // 只创建一次
      // if (subelement.length == 0) {
      //   $(editor.editorContainer).find(".tox-toolbar__group").eq(0).append(tipDom);
      // }
      // clearTimeout(this.tipTimeout);
      // this.tipTimeout = setTimeout(function () {
      //   var DeleteElement = $(".tox-toolbar__group .successfully:eq(0)");
      //   if (DeleteElement) {
      //     DeleteElement.remove()
      //   }
      // }, 500);

      var cacheArticle = this.$commonJs.getArticleDataFromCache(
        this.form.contentId
      );
      if (cacheArticle) {
        this.form.contentParagraphs = cacheArticle.contentParagraphs;
      } else {
        // 如果不存在，则新增一篇文章
        this.paragraphList.forEach((item) => {
          this.form.contentParagraphs.push({
            paragraphStyle: item.style,
            paragraphCode: item.code,
            paragraphName: item.desc,
            paragraphType: item.type,
            paragraphContent: item.content || "",
          });
        });
      }
      this.form.contentParagraphs[index].paragraphContent =
        editor.getContent() || "";
      this.$commonJs.setCacheArticleData(this.$commonJs.deepClone(this.form));
    },
    // 恢复段落内容
    restoreContentParagraphs({ editor, index }) {
      var article = this.$commonJs.getArticleDataFromCache(this.form.contentId);
      if (!article) {
        return;
      }
      this.$set(
        this.paragraphList[index],
        "content",
        article.contentParagraphs[index].paragraphContent
      );
    },
    //初始化获取文章标签和疾病标签
    init() {
      this.user_identity = sessionStorage.getItem("user_identity");
    },

    // 编写医生
    write_remoteMethod(query) {
      this.doctorList(query, "writeOptions", "write_doctor_loading");
    },
    writeChange() {
      if (this.writeDoctor == "") {
        this.writeOptions = [];
      }
    },
    doctorList(query, str, loadingStr) {
      if (query !== "") {
        this[loadingStr] = true;
        request("health_cmp_listByDoctorName", {
          tenantId: this.$commonJs.getTenantId(),
          doctorName: query,
        })
          .then((res) => {
            this[str] = res;
            this[loadingStr] = false;
          })
          .catch((err) => {
            this[str] = [];
            this[loadingStr] = false;
          });
      } else {
        this[str] = [];
      }
    },
    //获取文章详情
    getDiseaseInfoDraftDetail(CB) {
      request("health_cmp_queryContentDraftById", {
        contentId: this.form.contentId,
        tenantId: this.$commonJs.getTenantId(),
      })
        .then((res) => {
          this.form.contentStatus = res.contentStatus;
          this.form.contentAuditStatus = res.contentAuditStatus;
          // 检查缓存更新时间和最新更新时间确定是否删除缓存
          var cacheArticle = this.$commonJs.getArticleDataFromCache(
            res.contentId
          );
          if (cacheArticle) {
            try {
              var cacheUpdate = new Date(
                cacheArticle.updateTime.replace(/-/g, "/")
              );
              var lastUpdate = new Date(res.updateTime.replace(/-/g, "/"));
              if (lastUpdate.getTime() > cacheUpdate.getTime()) {
                this.$commonJs.removeCacheArticleData(res.contentId);
              }
            } catch (error) {
              console.log(error);
            }
          }
          this.displayInfo(res);
          CB && CB();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 是否跟换名称
    repealclickHandler(val) {
      if (val === "one") {
        this.reset_Diseases = false;
        this.getDiseaseInfoDraftDetail();
      } else if (val === "two") {
        this.reset_Diseases = false;
      }
    },

    //反显信息
    displayInfo(res) {
      // this.form.payType
      // this.form.vaccinationCount
      // this.form.vaccineCategories
      // this.form.contentType
      // this.form.contentRelations
      // this.form.contentParagraphs
      // this.form.doctorInfos
      // this.form.keywordInfos
      // this.form.tenantId
      // this.form.contentName
      // this.form.keywordInfos
      //反显疫苗名称
      if (res.contentName) {
        this.form.contentName = res.contentName;
      }

      if (res.auditInfo) {
        this.auditInfoShow = res.auditInfo.auditStatus;
      }
      //反显别名
      if (res.contentAliasNames) {
        this.form.contentAliasNames = res.contentAliasNames;
      }
      // 反显疫苗基本信息
      if (res.contentVaccine) {
        this.$refs.vaccineLabelref.checkList =
          res.contentVaccine.vaccineCategories.map((item) => item.code);
        this.vaccineCategories = res.contentVaccine.vaccineCategories.map(
          (item) => item.code
        );
        this.form.contentVaccine.vaccinationCount =
          res.contentVaccine.vaccinationCount;
        this.form.contentVaccine.payType = res.contentVaccine.payType;
      }
      //反显关键字
      if (res.keywordInfos) {
        this.$nextTick(() => {
          this.$refs.keywordsref.keywordInfos = [];
          res.keywordInfos &&
            res.keywordInfos.map((item, index) => {
              this.$refs.keywordsref.keywordInfos.push(item.keyword);
            });
        });
      }
      //反显关联疾病
      this.form.contentRelations = res.contentRelations || [];
      //反显段落
      this.form.contentParagraphs = res.contentParagraphs || [];
      var cache_article = this.$commonJs.getArticleDataFromCache(res.contentId);
      if (!cache_article) {
        var isFirstAdd = this.paragraphList.length == 0;
        res.contentParagraphs &&
          res.contentParagraphs.map((item, index) => {
            if (isFirstAdd) {
              this.paragraphList.push({
                style: item.style || this.paragraphListCategory[index].style,
                code: item.paragraphCode,
                desc:
                  item.paragraphName || this.paragraphListCategory[index].desc,
                type:
                  item.paragraphType || this.paragraphListCategory[index].type,
                content: item.paragraphContent || "",
              });
            } else {
              for (var i = 0; i < this.paragraphList.length; i++) {
                if (this.paragraphList[i].code == item.paragraphCode) {
                  this.paragraphList[i].content = item.paragraphContent || "";
                  this.paragraphList[i].style =
                    item.style || this.paragraphListCategory[i].style;
                  break;
                }
              }
            }
            try {
              var isEditorInited = setInterval(() => {
                var edd = this.editorList["editor" + index];
                if (edd) {
                  clearInterval(isEditorInited);
                  console.log(
                    this.editorList,
                    this.paragraphListCategory[index]
                  );
                  if (this.paragraphListCategory[index].style === 1) {
                    edd.setContent(item.paragraphContent || "");
                  }
                }
              }, 100);
            } catch (error) {
              console.log(error);
            }
          });
      }
      // this.writeOptions = []
      // if (res.doctorInfos) {
      //   res.doctorInfos.map(item => {
      //     if (item.roleType == 1) {
      //       this.writeOptions.push(item)
      //       this.writeDoctor = item.docId
      //     }
      //   })
      // }
    },
    // 删除弹框
    deleteClickHandler(val) {
      if (val === "one") {
        this.deleteForm.deleteDialog = false;
      } else if (val === "two") {
        // 清空contentID
        this.form.contentId = undefined;
        //疾病名称
        this.form.contentName = "";
        this.selectDiseaseInfoId = "";
        //别名
        this.form.aliasName = "";
        //科室
        this.selectedDeparttId = [];
        //关联疾病
        this.form.contentRelations = [];
        //段落
        this.paragraphList.map((item, index) => {
          item.content = "";
        });
        //关键字
        this.$refs.keywordsref.keywordInfos = [];
        this.deleteForm.deleteDialog = false;
      }
    },
    //获取疾病信息
    changeDiseaseLabels(data) {
      // 关联疾病
      this.form.contentRelations = data;
    },
    //获取段落信息
    getContentParagraphDictionary() {
      return new Promise((resolve, reject) => {
        request("health_cmp_biz_listParagraph", {
          type: 12, // 1疾病百科，3症状百科, 12是疫苗百科
          tenantId: this.$commonJs.getTenantId(),
        })
          .then((res) => {
            this.paragraphListCategory = res || [];
            this.paragraphList = res || [];
            resolve(res);
          })
          .catch((err) => {
            this.paragraphListCategory = [];
            this.paragraphList = [];
            reject(err);
          });
      });
    },
    editorReady(data) {
      this.editorList["editor" + data.index] = data.editor;
      this.restoreContentParagraphs(data);
    },
    editorChange(data, index) {
      // element组件特性
      this.$forceUpdate();
    },
    /**
     * @desc 由于某些特殊字段，无法使用vue v-model绑定操作，需要js手工赋值，故在保存，预览，提交，发布，审核文章前初始化一些表单的数据,比如上传图片，视频等信息
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：caogao:'草稿'，preview:'预览'，fabu:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     */
    initFormBeforeAddOrUpdate(val, opt_type) {
      // contentType 8: 疾病百科 9: 症状百科 13: 药品百科 16: 疫苗百科
      this.form.contentType = Number(this.actionType);
      //根据按钮状态修改articleStatus值 bugfix: 预览接口报异常 预览时 文章状态和草稿状态一致
      this.form.contentName = this.form.contentName.trim();
      //获取段落内容
      this.form.contentParagraphs = [];
      this.paragraphList.map((item, index) => {
        let paragraphContent = "";
        if (this.editorList["editor" + index]) {
          paragraphContent =
            typeof this.editorList["editor" + index] !== "string"
              ? this.editorList["editor" + index].getContent()
              : this.editorList["editor" + index];
        } else {
          paragraphContent = item.content;
        }
        this.form.contentParagraphs.push({
          style: item.style,
          paragraphCode: item.code,
          paragraphName: item.desc,
          paragraphType: item.type,
          paragraphContent: paragraphContent || "",
        });
      });
      this.form.contentVaccine.vaccineCategories = this.vaccineCategories.map(
        (item) => ({ code: item })
      );
      //关键词
      if (
        this.$refs.keywordsref.keywordInfos &&
        this.$refs.keywordsref.keywordInfos.length
      ) {
        let arr = [];
        this.$refs.keywordsref.keywordInfos.map((item) => {
          arr.push({
            keyword: item,
            keywordType: "1",
          });
        });
        this.form.keywordInfos = arr;
      } else {
        this.form.keywordInfos = [];
      }
    },
    /**
     * @desc 保存，预览，提交，发布，审核文章的检查函数
     * @param val  文章状态值 user端：0:第一次创建预览 1:草稿，2:发布，man端：3:保存文章，4:预览，5:通过
     * @param opt_type  user端：caogao:'草稿'，preview:'预览'，fabu:'发布'，man端： shenhe:'审核'，man-preview:'预览'，review:'保存文章'
     * @return true: 表单检查通过， false: ....
     */

    checkBeforeAddOrUpdate(val, opt_type) {
      // 保存文章状态不变
      if (!this.form.contentName || this.form.contentName.trim() == "") {
        this.$message.error("疫苗名称不能为空");
        return false;
      }
      //保存草稿，只校验标题
      if (
        (val == 1 || val == 0) &&
        (this.form.contentAuditStatus == 1 || !this.form.contentAuditStatus)
      ) {
        return true;
      }
      if (this.form.aliasName) {
        // if (!/^[\w\u4E00-\u9FA5,，、]+$/ig.test(this.form.aliasName)) {
        //   this.$message.error("别名只能使用英文逗号“,”, 中文“，”及顿号“、”分割");
        //   return false;
        // }
        // if (/[,、，]{2,}/ig.test(this.form.aliasName)) {
        //   this.$message.error("别名不可以重复两个符号");
        //   return false;
        // }
        // if (/^([,，、]+)/ig.test(this.form.aliasName) || /([,，、]+)$/ig.test(this.form.aliasName)) {
        //   this.$message.error("开头结尾不能为符号");
        //   return false;
        // }
      }
      if (this.form.contentVaccine.vaccineCategories.length === 0) {
        this.$message.error("疫苗分类不能为空");
        return false;
      }
      // 文本框全必填
      let paragraphsInputPass = [];
      let paragraphsInput = [];
      paragraphsInputPass = this.form.contentParagraphs.filter((item) => {
        if (item.style === 2 && item.paragraphContent == "") {
          paragraphsInput.push(item.paragraphName);
        }
        return item.style === 2 && item.paragraphContent == "";
      });
      if (paragraphsInputPass.length > 0) {
        this.$message.error(`${paragraphsInput.join(",")}不能为空`);
        return false;
      }
      // 段落至少有一项
      let isParagraphsPass = [];
      let paragraphsText = [];
      isParagraphsPass = this.form.contentParagraphs.filter((item) => {
        if (item.style === 1 && item.paragraphContent == "") {
          paragraphsText.push(item.paragraphName);
        }
        return item.style === 1 && item.paragraphContent != "";
      });
      if (isParagraphsPass.length < 1) {
        this.$message.error(paragraphsText.join(",") + "至少填写一项");
        return false;
      }
      if (!this.form.keywordInfos.length) {
        this.$message.error("关键词不能为空");
        return false;
      }
      return true;
    },
    // 保存
    saveOrUpdateDiseaseInfo(val, type) {
      this.initFormBeforeAddOrUpdate(val, type);
      if (!this.checkBeforeAddOrUpdate(val, type)) {
        return;
      }
      let reg = /data:image(.*);base64/g;
      for (let i = 0; i < this.form.contentParagraphs.length; i++) {
        if (reg.test(this.form.contentParagraphs[i].paragraphContent)) {
          this.$message.error(
            "目前暂不支持复制图片，请使用添加图片功能上传图片"
          );
          return false;
        }
      }
      let params = this.$commonJs.deepClone(this.form);
      const functionId = this.form.contentId
        ? "health_cmp_biz_writerUpdateVaccine"
        : "health_cmp_biz_writerSaveVaccine";
      // return;
      request(functionId, params)
        .then((res) => {
          if (!this.form.contentId) {
            this.form.contentId = res.contentId;
          }
          let contentIds = {
            contentId: this.form.contentId,
            tenantId: this.$commonJs.getTenantId(),
          };
          // 预览
          if (type == "preview") {
            this.articlePreview(contentIds);
          }
          //保存草稿
          if (type == "draft") {
            this.$message.success("保存成功");
          } else if (type == "submit") {
            // auditStatus:1草稿、2待审核、3审核通过、4驳回 9撤销投稿
            params.auditInfo = { auditStatus: 2 };
            request("health_cmp_publishContent", {
              contentId: res.contentId,
              tenantId: this.$commonJs.getTenantId(),
            })
              .then((res) => {
                if (res) {
                  this.$router.push(`/manageBK`);
                }
                this.$message.success("提交成功");
              })
              .catch((err) => {
                this.$message.error(err.msg + "发布失败");
              });
          }
        })
        .catch((error) => {
          this.$message.error(error.msg || "操作失败！");
        });
    },
    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      this.jumpUrl("preview/", val.contentId);
    },
    jumpUrl(type, urlId) {
      let isDev = process.env.VUE_APP_BASEURL == "//beta-api.m.jd.com";
      let vaccinePreview = "https://cont-yf.healthjd.com/wiki/vaccine/"; // 疫苗预发地址
      let vaccineOnline = "https://cont.healthjd.com/wiki/vaccine/"; // 线上疫苗
      let newUrl = `${isDev ? vaccinePreview : vaccineOnline}${type}${urlId}`;
      this.mUrl = newUrl;
      getQRCode(newUrl, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    checkoutVaccineLabel(vaccineCategories) {
      this.vaccineCategories = vaccineCategories;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/article_common.scss";

.article {
  @include article_common;
  .item-video-wrap {
    border: 1px solid #c0c4cc;
  }

  :deep(.el-form-item) {
    margin-bottom: 22px;
  }
  :deep(.el-textarea__inner) {
    resize: none;
    overflow: hidden;
    overflow-y: auto;
    display: inline-block;
    margin-bottom: 45px;
    height: 92px;
    margin-right: 15px;
  }

  :deep(.el-dialog__body) {
    padding: 30px 26px 0px 26px !important;
  }

  .el-button {
    line-height: 10px;
  }

  .article_tit {
    .el-input__suffix {
      left: 100% !important;
      right: auto !important;
    }
  }
}

.finish-buttons {
  width: 307px;
  height: 32px !important;
  margin-top: 62px;
  margin-left: 61px;
}

.article .wrap .writeDoc .el-input {
  width: 645px !important;
}
.textArea-flex {
  align-items: flex-start;
}
.content-item.textArea-flex {
  :deep(.el-textarea__inner) {
    margin-bottom: 0;
  }
}
</style>
